import { Chip, Stack, Typography } from '@mui/material'
import { useMemo } from 'react'

import { Maybe, PreSaleStatus } from '@/clients/utoniq-core/schema'
import { State } from '@/components/pages/FirstComeFirstServedDetail/template'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type FirstComeFirstServedContentCellProps = {
  preSale: State['preSale']
}
export const FirstComeFirstServedContentCell: Cell<FirstComeFirstServedContentCellProps> =
  ({ preSale }) => {
    const { t } = useTranslation('firstComeFirstServedDetail')

    return (
      <CellFrame sx={{ pb: 5 }}>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ py: 2 }}>
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{ flex: 1, minWidth: 'fit-content' }}
          >
            <Chip
              variant="outlined"
              label={
                <Typography variant="overline">
                  {t('firstComeFirstServed', '先着')}
                </Typography>
              }
              sx={{
                bgcolor: 'background.default',
                p: 0,
                height: 20,
                '.MuiChip-label': { p: 1 },
              }}
            />
            <PreSaleStatusTag status={preSale?.preSaleStatus} />
          </Stack>
          <Typography width="100%" variant="subtitle1">
            {preSale?.event.title}
          </Typography>
        </Stack>
        <Typography variant="body2">{preSale?.description}</Typography>
      </CellFrame>
    )
  }

type PreSaleStatusTagProps = {
  status: Maybe<PreSaleStatus> | undefined
}
const PreSaleStatusTag: Cell<PreSaleStatusTagProps> = ({ status }) => {
  const { t } = useTranslation('firstComeFirstServedDetail')

  const bgcolor = useMemo(() => {
    switch (status) {
      case PreSaleStatus.Accepting:
        return 'primary.main'
      case PreSaleStatus.BeforeReceiption:
        return 'secondary.main'
      case PreSaleStatus.SoldOut:
        return 'error.main'
      default:
        return 'grey.300'
    }
  }, [status])

  if (!status) return null

  return (
    <Chip
      label={
        <Typography variant="overline" color="white">
          {t(status)}
        </Typography>
      }
      sx={{
        p: 0,
        bgcolor,
        height: 20,
        '.MuiChip-label': { p: 1 },
      }}
    />
  )
}
